import $ from "jquery";

document.addEventListener("DOMContentLoaded", function () {
// Функция для обработки клика по кнопкам .buy-{номер}
    // Функция для обработки клика по кнопкам .buy-{номер}
    document.addEventListener('click', function (event) {
        // Проверяем, что клик произошел по кнопке с классом, содержащим "buy-"
        const targetElement = event.target.closest('[class*="buy-"]'); // Ищем ближайший элемент с классом, содержащим "buy-"

        if (targetElement) {
            console.log('пух'); // Лог для проверки

            // Извлекаем номер из класса кнопки
            const buttonClasses = targetElement.className.split(' ');
            const buyClass = buttonClasses.find(className => className.startsWith('buy-'));

            if (buyClass) {
                const offerId = buyClass.replace('buy-', ''); // Извлекаем номер из класса

                // Ищем соответствующую кнопку с классом ._shopaholic-cart-add и data-offer-id
                const shopaholicButton = document.querySelector(`._shopaholic-cart-add[data-offer-id="${offerId}"]`);

                if (shopaholicButton) {
                    // Имитируем нажатие на кнопку
                    shopaholicButton.click();
                    console.log(`Имитировано нажатие на кнопку с offer-id: ${offerId}`);
                } else {
                    console.error(`Кнопка с data-offer-id="${offerId}" не найдена`);
                }
            }
        }
    });

        const images = document.querySelectorAll('#iid89s img'); // Находим все изображения в отзывах
    console.log(images);
    console.log('картинки');

    images.forEach((img) => {
        // Проверка доступности изображения
        img.onerror = function () {
            // Если изображение не загрузилось, заменяем его на заглушку
            this.src = '/themes/main/assets/img/profile.svg';
        };

        // Если изображение уже не загрузилось до привязки обработчика
        if (!img.complete || img.naturalWidth === 0) {
            img.onerror();
        }
    });

    document.querySelector('.header').style.backgroundColor = 'transparent';

    var mobile_header = $('.mobile-header');
    var modal = $('.modal');
    var modal__feedback = $('.modal-feedback');
    var overlay = $('.overlay');

    $("form.needs-validation").each(function () {
        $(this).submit(function (event) {
            $(document).on('ajaxSetup', function (event, context) {
                context.options.flash = true
                context.options.loading = $.oc.stripeLoadIndicator

                context.options.handleFlashMessage = function (message, type) {
                    $('#restorePasswordError').html(message);
                    $('#restorePasswordError').show();
                    $('#restorePasswordError')[0].animate([
                        {transform: 'rotate(0deg)'},
                        {transform: 'rotate(0deg)'},
                        {transform: 'rotate(5deg)'},
                        {transform: 'rotate(-5deg)'},
                        {transform: 'rotate(0deg)'}
                    ], {
                        // timing options
                        duration: 100,
                        iterations: 2,
                        delay: 300
                    })
                    setTimeout(() => {
                        $('#restorePasswordError').hide();
                    }, 7000);
                    $.oc.flashMsg({text: message, class: type})
                }
            })
        })
    })

    $('.newModal').click(function () {
        modal__sign_up_on_consultation.addClass("modal-on");
        overlay.addClass("overlay-on");
        $('html, body').css({
            overflow: 'hidden'
        });
    });

    $('.call').click(function () {
        var title = $(this).data("title");
        if (title == null || title == undefined) {
            var title = $(this).attr('title');
        }
        $('#modalTitle').html(title);

        var content = $(this).data("partial");
        if (content == null) {
            var content = $(this).data("toggle");
        }
        $.request('onModalUpdate', {
            update: {[content]: '#modalContent'}
        });
        modal__feedback.addClass("modal-on");
        overlay.addClass("overlay-on");
        $('html, body').css({
            overflow: 'hidden'
        });
    });

    $('#nominal').on('change', function () {
        var sertificate_id = this.value;
        console.log(sertificate_id);
        $('.purchase-sertificate').attr('data-offer-id', sertificate_id);
    });
    $('.form5').on('click', 'button[name=add-to-cart]', function () {
        $.request('Cart::onClear', {});
        var offer_id = $(this).attr('data-offer-id');
        var data = {
            cart: [{
                offer_id: offer_id,
                quantity: 1
            }]
        };
        console.log(data);
        $.request('Cart::onAdd', {
            data: data,
            success: function success() {
                window.location.replace("/checkout");
            },
            error: function error() {
                alert('Не доступно к покупке');
            }
        });
        return false;
    });

    function updateModal(title, content) {
        $('#modalTitle').html(title);
        $.request('onModalUpdate', {
            update: {[content]: '#modalContent'},
            data: {title: title}
        });
    }

    $('.modal--closed, .mobile-header--close, .overlay').click(function () {
        var title = 'Загрузка...';
        var content = 'modals/preloader';
        updateModal(title, content);
        modal.removeClass("modal-on");
        overlay.removeClass("overlay-on");
        $('html, body').css({overflow: 'auto'});

        if ($(this).hasClass('mobile-header--close')) {
            mobile_header.removeClass("burder-button--flex");
            $('.header-background').css({"display": "block"});
        }
    });


    $('.overlay').click(function () {
        modal.removeClass("modal-on");
        overlay.removeClass("overlay-on");
        $('html, body').css({
            overflow: 'auto'
        });
    });


    $('.about-us--mobile').click(function () {
        $('.nav-list__inner--mobile').toggle();
    })

    $('.burger-button').click(function () {
        mobile_header.addClass("burder-button--flex");
        $('.header-background').css({"display": "none"});
    })

    $('.fifth-block__slider').slick({
        arrows: false,
        dots: true,
    })

    $('.eight-block__slider').slick({
        arrows: false,
        dots: true,
    })

    $('.room__images').slick({
        dots: false,
        prevArrow: $('.arrow-back'),
        nextArrow: $('.arrow-next'),
    })

    $('.ninth-block__dots').slick({
        slidesToShow: 18,
        infinite: false,
        slidesToScroll: 1,
        asNavFor: '.ninth-block__slider',
        dots: false,
        centerMode: false,
        focusOnSelect: true
    });

    $('.ninth-block__slider').slick({
        arrows: false,
        dots: false,
        slidesToShow: 1,
        asNavFor: '.ninth-block__dots'
    })

    $('.sertificates__slider').slick({
        arrows: false,
        dots: false,
        slidesToShow: 1,
        fade: true,
        asNavFor: '.sertificates__dots'
    })

    $('.sertificates__dots').slick({
        slidesToShow: 11,
        slidesToScroll: 1,
        asNavFor: '.sertificates__slider',
        dots: false,
        centerMode: false,
        focusOnSelect: true
    });

    $('.licening-documents__slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
    });

    $('.rent-block__slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
    });

    $('.thanks-slider').slick({
        arrows: false,
        dots: false,
        slidesToShow: 1,
    })

    $('.reviews-dots').slick({
        slidesToShow: 10,
        slidesToScroll: 1,
        asNavFor: '.thanks-slider',
        dots: false,
        centerMode: false,
        focusOnSelect: true
    });

    $('.paid-trainings__slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: false,
        prevArrow: $('.prev-arrow'),
        nextArrow: $('.next-arrow'),
        responsive: [
            {
                breakpoint: 960,
                settings: "unslick"
            }
        ]
    });

    $('.carousel-inner').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: $('.carousel-control-prev'),
        nextArrow: $('.carousel-control-next'),
    })


    $('.treaning-tabs').each(function () {
        let ths = $(this);
        ths.find('.treaning-tabs__block').not(':first').hide();
        ths.find('.treaning-tabs__item').click(function () {
            ths.find('.treaning-tabs__item').removeClass('active').eq($(this).index()).addClass('active');
            ths.find('.treaning-tabs__block').hide().eq($(this).index()).fadeIn()
        }).eq(0).addClass('active');
    });

    $('.show-more').click(function () {
        $('.text-toggle').slideToggle(300);
    });

    $('.schedule__button').click(function () {
        var a = $(this).attr('id');
        $("." + a + '-tabble').slideToggle();
    });

    $('.treaning-info__description--mobile--on').click(function () {
        $('.treaning-info__description--mobile').slideToggle();
        $(this).slideToggle();
    });

    $('.reg_user_btn').click(function () {
        $('#loadingmessage').show();
        $.request('Registration::onCheckEmail', {
            data: {'email': $('input[name="email"]').val()},
            success: function (data) {
                if (data.status) {
                    console.log(data.status);
                } else {
                    alert('Ваш email уже зарегистрирован в системе');
                }
                $('#loadingmessage').hide();
            }
        });
    });

    // function loadCSS(url) {
    //   var link = document.createElement('link');
    //   link.rel = 'stylesheet';
    //   link.href = url;
    //   document.head.appendChild(link);
    // }
    // setTimeout(function() {
    //   loadCSS('styles-noncritical.css');
    // }, 2000);
    $(document).on('click', '.reg_user_btn_login', function () {
        console.log('reg_user_btn');
        $('#loadingmessage').show();  // Показываем индикатор загрузки
        $.request('Login::onAjax', {
            data: {
                email: $('input[name="email"]').val(),  // Получаем email
                password: $('input[name="password"]').val()  // Получаем пароль
            },
            success: function (data) {
                if (data.status) {
                    // Если авторизация успешна, показываем сообщение и выполняем редирект
                    alert(data.message);
                    window.location.href = '/';  // Перенаправляем на главную страницу
                } else {
                    // Если ошибка, показываем сообщение об ошибке
                    alert(data.message);
                }
                $('#loadingmessage').hide();  // Скрываем индикатор загрузки
            },
            error: function () {
                alert('Произошла ошибка при авторизации. Попробуйте снова.');
                $('#loadingmessage').hide();  // Скрываем индикатор загрузки
            }
        });
    });



    console.log('Личный кабинет');
    $(document).on('click', '.hide-order-btn', function() {
        var orderId = $(this).data('order-id'); // Получаем ID заказа
        var button = $(this);  // Кнопка, на которую нажали

        // Проверяем, существует ли orderId
        if (!orderId) {
            console.error("ID заказа не найден");
            alert("Ошибка: ID заказа не найден");
            return;
        }

        // Проверяем, что кнопка существует на странице
        if (!button.length) {
            console.error("Кнопка скрытия заказа не найдена на странице");
            alert("Ошибка: Кнопка скрытия заказа не найдена");
            return;
        }

        // Отправляем AJAX-запрос на сервер для скрытия заказа
        $.request('onHideOrder', {
            data: {
                order_id: orderId
            },
            success: function(response) {
                if (response.success) {
                    // Убираем заказ из списка на странице
                    button.closest('.paid-trainings__item').remove();
                    alert(response.message);
                } else {
                    alert(response.message);
                }
            },
            error: function() {
                alert('Ошибка при скрытии заказа');
            }
        });
    });


});


var tabs = document.querySelectorAll(".tabs");

if (tabs.length > 0) {
// Табы найдены на странице
    var tabContents = document.querySelectorAll(".tab-content");

    tabContents.forEach(function (tabContent) {
        var button = tabContent.querySelector("button");
        var content = tabContent.querySelector("p");
        var svg = tabContent.querySelector("svg");

        button.addEventListener("click", function () {
            tabContent.classList.toggle("active");
            if (tabContent.classList.contains("active")) {
                content.style.maxHeight = content.scrollHeight + "px";
                svg.classList.add("rotate");
            } else {
                content.style.maxHeight = "0";
                svg.classList.remove("rotate");
            }
        });
    });
} else {
}

document.addEventListener("DOMContentLoaded", function() {
    if (window.location.href.includes("order-complete-page")) {
        $.request('Cart::onClear', {});
        const notificationElement = document.querySelector(".message-icon.cartNotification");
        if (notificationElement) {
            notificationElement.style.display = "none"; // Скрываем элемент
        }
    }
});
